import React from "react";
import FormikInput from "../../../../../base/components/FormikInput";
import {MAX_TITLE_LENGTH, MAX_UNIT_LENGTH} from "./constants";
import {FormAvatar} from "../../../../../base/components/Dropzone/Dropzone";
import {validateFile} from "../../../HealthProgram/Wellness/Form/form";
import {DropZonePlaceholder} from "../../../Fitness/WorkoutForm/form";

const WidgetForm = ({values}) => {
    return (
        <div className="d-flex flex-column gap-3">
            <FormikInput
                id="label"
                name="label"
                label="Title"
                containerClassName="relative w-100"
                placeholder="Enter title"
                type="text"
                maxLength={MAX_TITLE_LENGTH}
            />
            <FormikInput
                id="unit"
                name="unit"
                label="Unit"
                containerClassName="relative w-100"
                placeholder="Enter unit"
                type="text"
                maxLength={MAX_UNIT_LENGTH}
            />
            <div>
                <label>Icon</label>
                <FormAvatar
                    validateFile={validateFile}
                    fieldName="icon"
                    dropZonePlaceholder={<DropZonePlaceholder fileType={"image"} />}
                    dropZoneTitle={<div className="text-center">
                        <div>Upload an Icon</div>
                        <div>(Required)</div>
                    </div>}
                    hasCropper={false}
                />
            </div>
            <div>
                <label>Placeholder Icon</label>
                <FormAvatar
                    validateFile={validateFile}
                    fieldName="placeholderIcon"
                    dropZonePlaceholder={<DropZonePlaceholder fileType={"image"} />}
                    dropZoneTitle={<div className="text-center">
                        <div>Upload a Placeholder Icon</div>
                        <div>(Required)</div>
                    </div>}
                    hasCropper={false}
                />
            </div>
        </div>
    )
}

export default WidgetForm;